$(window).on('load', function() {
  $('#js-loader')
    .delay(600)
    .fadeOut(800)
})
